module.exports = __webpack_public_path__ + "img/no-result-1.188fd040.png";